import { lazy } from "react";
import { Navigate } from "react-router";
import Loadable from "src/routes/Loadable";

const Wrapper = Loadable(lazy(() => import("src/pages/admin/aum-chart")));
const Chart = Loadable(lazy(() => import("src/pages/admin/aum-chart/chart")));
const Category = Loadable(
  lazy(() => import("src/pages/admin/aum-chart/category")),
);

const aumChart = [
  {
    path: "aum-chart",
    element: <Wrapper />,
    children: [
      { element: <Navigate to="chart" />, index: true },
      { path: "chart", element: <Chart /> },
      { path: "category", element: <Category /> },
    ],
  },
];

export default aumChart;
